import { render } from "./ExceptionTable.vue?vue&type=template&id=25118820&scoped=true"
import script from "./ExceptionTable.vue?vue&type=script&lang=js"
export * from "./ExceptionTable.vue?vue&type=script&lang=js"

import "./ExceptionTable.vue?vue&type=style&index=0&id=25118820&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25118820"]])

export default __exports__